import { ErrorMessage, Form, Formik, FormikErrors } from "formik";
import { observer } from "mobx-react-lite";
import { useState } from "react";
import { useTranslation } from "react-i18next";
import { Button, Divider, DropdownItemProps } from "semantic-ui-react";
import { useStore } from "../../app/stores/store";
import PageHeader from "../../app/layout/PageHeader";
import ValidationErrors from "../errors/ValidationErrors";
import { NewLocationFormValues } from "../../app/models/inventory";
import MyIconTextInput from "../../app/common/form/MyIconTextInput";

interface Props {
  closeModal?: (values?: DropdownItemProps) => void;
 }

export default observer(function AddNewLocationModal({
  closeModal
}: Props) {
  const { t } = useTranslation(["common", "tickets", "inventory"]);

  const [locationFormValues] = useState<NewLocationFormValues | undefined>(new NewLocationFormValues());
  const { inventoryIndexStore } = useStore();
  const { addNewLocation } = inventoryIndexStore; 

  function handleFormSubmit(
    values: NewLocationFormValues,
    setErrors: (errors: FormikErrors<NewLocationFormValues>) => void,
    setSubmitting: (isSubmitting: boolean) => void
  ) {
    addNewLocation(values)
      .then((result) => {
        closeModal?.(result as DropdownItemProps);
      })
      .catch((error) => {
        setSubmitting(false);
        setErrors(error);
      });
  }
  return (
    <Formik
      initialValues={{
        location: locationFormValues?.location ?? ""
      } as NewLocationFormValues}
      onSubmit={(values, { setErrors, setSubmitting }) =>
        handleFormSubmit(values, setErrors, setSubmitting)
      }
    >
      {({
        handleSubmit,
        isValid,
        isSubmitting,
        dirty,
        errors,
      }) => (
        <Form className="ui form error" autoComplete="off" onSubmit={handleSubmit}>
          <PageHeader header={t("labels.addNewLocation", { ns: "inventory" })} type={"h3"} divider={true} getAlerts={true} addTitle={false} />
          <ErrorMessage
            name="error"
            render={() => <ValidationErrors errors={errors.location} />}
          />
          <MyIconTextInput
            icon="marker"
            iconPosition="left"
            placeholder={`${t("sampleLocation", { ns: "inventory" })}`}
            label={`${t("labels.locationName", { ns: "inventory" })}:`}
            name="location"
            maxLength={500}
          />
          <Divider></Divider>
          <Button
            color="green"
            className="save_button"
            icon="check"
            content={t("save", { ns: "common" })}
            disabled={isSubmitting || !dirty || !isValid}
            loading={isSubmitting}
            type="submit"
          />
          <Button
            className="save_button"
            onClick={() => closeModal?.()}
            icon="cancel"
            type="reset"
            content={t("cancel", { ns: "common" })}
          />
        </Form>
      )}
    </Formik>
  );
});
